import { createV2EventTracker } from '../util';
import {
  StoryAIAnswersFirstMessageSent,
  StoryAIAnswersSuggestion,
  StoryAISummaryFeedback,
  StoryAIAnswersFeedback,
} from './types';

export const trackStoryAISummaryFeedback = createV2EventTracker<StoryAISummaryFeedback>(
  'StoryAI Summary Feedback',
);

export const trackStoryAIAnswersFeedback = createV2EventTracker<StoryAIAnswersFeedback>(
  'StoryAI Answers Feedback',
);

export const trackStoryAIAnswersSuggestion = createV2EventTracker<StoryAIAnswersSuggestion>(
  'StoryAI Answers Suggestion',
);

export const trackStoryAIAnswersFirstMessageSent =
  createV2EventTracker<StoryAIAnswersFirstMessageSent>('StoryAI Answers First Message Sent');
